import React, { useState, useContext } from 'react'
import { NavLink } from 'react-router-dom'

import { ReactComponent as CalendarIcon } from 'i/icons/calendar_4_white.svg'
import { ReactComponent as AvailableIcon } from 'i/icons/available_white.svg'
import { ReactComponent as ClassesIcon } from 'i/icons/classes_white.svg'
import { ReactComponent as VideoIcon } from 'i/icons/play-media_white.svg'
import { ReactComponent as ProfileIcon } from 'i/icons/profile_white.svg'
import { ReactComponent as HelpIcon } from 'i/icons/help_white.svg'

import { MENU_DATA, PAGE_NAMES } from '../../data'
import sessionTypes from 'utils/sessionTypes.json'

import styles from './Menu.module.scss'
import { UiContext } from 'context/ui'
import { POPUPS_ID } from 'utils/constants'

const Menu = ({
  clickToggle,
  setDashboardContent,
  dashboardContentCurrentState,
  proCategory,
}) => {
  const { setActivePopupId } = useContext(UiContext)
  const [isChatPopupOpen, setIsChatPopupOpen] = useState(false)

  const getScheduleLabel = () => {
    const mappedType = sessionTypes?.[proCategory]
    if (!mappedType) return PAGE_NAMES.schedule

    if (mappedType === 'Class') return 'Classes'
    if (mappedType.endsWith('s')) return mappedType

    return `${mappedType}s`
  }

  const renderIcon = (title) => {
    if (!title) return null

    const menuLinkIcon = styles.menuLinkIcon

    switch (title) {
      case PAGE_NAMES.schedule:
        return <CalendarIcon className={menuLinkIcon} />

      case PAGE_NAMES.availability:
        return <AvailableIcon className={menuLinkIcon} />

      case PAGE_NAMES.classes:
        return <ClassesIcon className={menuLinkIcon} />

      case PAGE_NAMES.videoes:
        return <VideoIcon className={menuLinkIcon} />

      case PAGE_NAMES.profile:
        return <ProfileIcon className={menuLinkIcon} />

      case PAGE_NAMES.help:
        return <HelpIcon className={menuLinkIcon} />

      default:
        return null
    }
  }

  const renderContent = (title) => {
    const displayTitle = title === PAGE_NAMES.schedule ? getScheduleLabel() : title

    return (
      <>
        {renderIcon(title)}
        {displayTitle}
      </>
    )
  }

  const showPopup = (popupId) => {
    clickToggle()
    setActivePopupId(popupId)
  }

  const toggleChatPopup = () => {
    clickToggle()
    setIsChatPopupOpen(!isChatPopupOpen)
  }

  return (
    <nav className={styles.menu}>
      <div className={styles.menuButtonWrap}>
        <button
          type="button"
          className={styles.menuButton}
          onClick={() => showPopup(POPUPS_ID.sendInvite)}
        >
          <span>+</span> Invite
        </button>
      </div>

      <ul className={styles.menuList}>
        {MENU_DATA &&
          MENU_DATA.map(({ title, url, target, popupId, dashboardContent }) => {
            const linkActiveState =
              dashboardContent && dashboardContentCurrentState
                ? dashboardContent === dashboardContentCurrentState
                  ? styles.menuLinkActive
                  : false
                : styles.menuLinkActive

            return (
              <li className={styles.menuItem} key={title}>
                {popupId ? (
                  <button
                    type="button"
                    className={styles.menuLink}
                    onClick={() => showPopup(popupId)}
                  >
                    {renderContent(title)}
                  </button>
                ) : title === PAGE_NAMES.help ? (
                  <button
                    type="button"
                    className={styles.menuLink}
                    onClick={toggleChatPopup}
                  >
                    {renderContent(title)}
                  </button>
                ) : target ? (
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.menuLink}
                  >
                    {renderContent(title)}
                  </a>
                ) : (
                  <NavLink
                    className={styles.menuLink}
                    activeClassName={linkActiveState}
                    to={url}
                    onClick={
                      dashboardContent && setDashboardContent
                        ? () => setDashboardContent(dashboardContent)
                        : null
                    }
                  >
                    {renderContent(title)}
                  </NavLink>
                )}
              </li>
            )
          })}
      </ul>

      <div className={`${styles.chat_popup} ${isChatPopupOpen ? styles.open : ''}`}>
        <button className={styles.close_button} onClick={toggleChatPopup}>
          ×
        </button>
        <iframe
          src="https://chat.supportai.com/1ca8ddb59c38d0a/"
          frameBorder="0"
          title="Support Chat"
        ></iframe>
      </div>
    </nav>
  )
}

export default Menu
